<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Maszyny drukujące</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/plates">Maszyny drukujące</router-link>
        </li>
        <li class="active">
          <strong>Nowa</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isMainOpen = !isMainOpen">
            <h5>Maszyny drukujące</h5>
            <span class="ibox-toggle">
              <i :class="chevronMainClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isMainOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="plateObj.name"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Wymiar x</label>
                <div class="col-sm-10">
                  <input
                    v-model="plateObj.size_x"
                    name="size_x"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Wymiar x"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.size_x" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.size_x[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Wymiar y</label>
                <div class="col-sm-10">
                  <input
                    v-model="plateObj.size_y"
                    name="size_y"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Wymiar y"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.size_y" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.size_y[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Cena</label>
                <div class="col-sm-10">
                  <input
                    v-model="plateObj.price"
                    name="price"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Cena"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.price" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.price[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Max format zadruku</label>
                <div class="col-sm-10 flex-inputs">
                  <div>
                    <input
                      v-model="plateObj.max_print_x"
                      type="text"
                      class="form-control inputClass"
                      placeholder="x"
                      required="required"
                    />
                    <div
                      v-if="errorsAdminData?.data?.max_print_x"
                      class="has-error"
                    >
                      <span class="help-block">
                        {{ errorsAdminData.data.max_print_x[0] }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <input
                      v-model="plateObj.max_print_y"
                      type="text"
                      class="form-control inputClass"
                      placeholder="y"
                      required="required"
                    />
                    <div
                      v-if="errorsAdminData?.data?.max_print_y"
                      class="has-error"
                    >
                      <span class="help-block">
                        {{ errorsAdminData.data.max_print_y[0] }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Min format zadruku</label>
                <div class="col-sm-10 flex-inputs">
                  <div>
                    <input
                      v-model="plateObj.min_print_x"
                      type="text"
                      class="form-control inputClass"
                      placeholder="x"
                      required="required"
                    />
                    <div
                      v-if="errorsAdminData?.data?.min_print_x"
                      class="has-error"
                    >
                      <span class="help-block">
                        {{ errorsAdminData.data.min_print_x[0] }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <input
                      v-model="plateObj.min_print_y"
                      type="text"
                      class="form-control inputClass"
                      placeholder="y"
                      required="required"
                    />
                    <div
                      v-if="errorsAdminData?.data?.min_print_y"
                      class="has-error"
                    >
                      <span class="help-block">
                        {{ errorsAdminData.data.min_print_y[0] }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Format matrycy</label>
                <div class="col-sm-10 flex-inputs">
                  <div>
                    <input
                      v-model="plateObj.matrix_x"
                      type="text"
                      class="form-control inputClass"
                      placeholder="x"
                      required="required"
                    />
                    <div
                      v-if="errorsAdminData?.data?.matrix_x"
                      class="has-error"
                    >
                      <span class="help-block">
                        {{ errorsAdminData.data.matrix_x[0] }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <input
                      v-model="plateObj.matrix_y"
                      type="text"
                      class="form-control inputClass"
                      placeholder="y"
                      required="required"
                    />
                    <div
                      v-if="errorsAdminData?.data?.matrix_y"
                      class="has-error"
                    >
                      <span class="help-block">
                        {{ errorsAdminData.data.matrix_y[0] }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <input
                      v-model="plateObj.matrix_cost_per_m2"
                      type="text"
                      class="form-control inputClass"
                      placeholder="Koszt [m2]"
                      required="required"
                    />
                    <div
                      v-if="errorsAdminData?.data?.matrix_cost_per_m2"
                      class="has-error"
                    >
                      <span class="help-block">
                        {{ errorsAdminData.data.matrix_cost_per_m2[0] }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2"
                  >Wydajność [arkusz/h]</label
                >
                <div class="col-sm-10">
                  <input
                    v-model="plateObj.sheets_per_hour"
                    name="sheets_per_hour"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Wydajność [arkusz/h]"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.sheets_per_hour"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.sheets_per_hour[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div
                v-for="(cost, key) in operational_costs"
                :key="key"
                class="form-group"
              >
                <label class="control-label col-sm-2">
                  <div v-if="key === 0">
                    Koszty eksploatacyjne stałe
                    <button @click="addCost" class="btn btn-default">
                      Dodaj
                    </button>
                  </div>
                </label>
                <div class="col-sm-10 flex-inputs">
                  <div class="mr-20">
                    <div class="multiselect-with-buttons">
                      <Multiselect
                        v-model="operational_costs[key].type"
                        mode="single"
                        placeholder="Typ"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :resolve-on-blur="false"
                        :options="units"
                        :object="true"
                        :filter="customFilter"
                        class="flexible-multiselect"
                        @open="() => {}"
                        @select="() => {}"
                      >
                        <template #option="{ option }">
                          <div class="option-with-delete">
                            <button
                              v-if="canDeleteUnit"
                              type="button"
                              class="btn btn-sm btn-danger delete-btn"
                              @click.stop="confirmDeleteUnit(option)"
                              title="Usuń jednostkę"
                            >
                              ×
                            </button>
                            <span class="option-text">
                              {{ option.name }} ({{ option.symbol }})
                            </span>
                          </div>
                        </template>
                      </Multiselect>
                      <button
                        v-if="canAddUnit"
                        type="button"
                        class="btn btn-sm btn-success add-unit-btn"
                        @click="showUnitModal = true"
                        title="Dodaj nową jednostkę"
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <div class="mr-20">
                    <input
                      v-model="operational_costs[key].name"
                      name="name"
                      type="text"
                      class="form-control inputClass"
                      placeholder="Nazwa"
                      required="required"
                    />
                    <div v-if="errorsAdminData?.data?.name" class="has-error">
                      <span class="help-block">
                        {{ errorsAdminData.data.name[0] }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <input
                      v-model="operational_costs[key].amount"
                      name="format_y"
                      type="text"
                      class="form-control inputClass"
                      placeholder="Wartość"
                      required="required"
                    />
                    <div
                      v-if="errorsAdminData?.data?.format_y"
                      class="has-error"
                    >
                      <span class="help-block">
                        {{ errorsAdminData.data.format_y[0] }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="hr-line-dashed"></div>

              <div class="form-group">
                <div class="col-sm-4 col-sm-offset-2">
                  <button class="btn btn-white" @click="cancel">Anuluj</button>
                  <button
                    v-if="canAddPlate"
                    @click="create"
                    class="btn btn-primary"
                  >
                    Zapisz
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal for creating new unit -->
  <div
    v-if="showUnitModal"
    class="modal fade show"
    style="display: block; background-color: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Dodaj nową jednostkę</h4>
          <button type="button" class="close" @click="showUnitModal = false">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>Nazwa jednostki</label>
            <input
              v-model="newUnit.name"
              type="text"
              class="form-control"
              placeholder="np. Kilowatogodzina"
            />
          </div>
          <div class="form-group">
            <label>Symbol</label>
            <input
              v-model="newUnit.symbol"
              type="text"
              class="form-control"
              placeholder="np. kWh"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="showUnitModal = false"
          >
            Anuluj
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="createUnit"
            :disabled="!newUnit.name || !newUnit.symbol"
          >
            Dodaj jednostkę
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal potwierdzenia usuwania jednostki -->
  <div
    v-if="showDeleteConfirmModal"
    class="modal fade show"
    style="display: block; background-color: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Potwierdź usunięcie</h4>
          <button
            type="button"
            class="close"
            @click="showDeleteConfirmModal = false"
          >
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>
            Czy na pewno chcesz usunąć jednostkę
            <strong>{{ selectedUnitForDelete?.name }}</strong>
            ({{ selectedUnitForDelete?.symbol }})?
          </p>
          <p class="text-danger">
            <small>Ta operacja nie może być cofnięta.</small>
          </p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="showDeleteConfirmModal = false"
          >
            Anuluj
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="executeDeleteUnit"
          >
            Usuń
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch, onMounted } from "vue";
import { hasPermission } from "../../permissions";
import {
  platePermissionsConst,
  unitPermissionsConst,
} from "../../constants/productionConstants";
import { useStore } from "vuex";
import router from "../../router/router";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

export default {
  name: "PlateesCreate",
  mixins: [],
  components: {
    Multiselect,
  },
  props: {},

  setup() {
    const plateObj = ref({
      name: "",
      size_x: "",
      size_y: "",
      price: "",
      max_print_x: "",
      max_print_y: "",
      min_print_x: "",
      min_print_y: "",
      matrix_x: "",
      matrix_y: "",
      matrix_cost_per_m2: "",
      sheets_per_hour: "",
    });

    const operational_costs = ref([
      {
        name: "",
        type: "",
        amount: 0,
      },
    ]);

    const units = ref([]);
    const showUnitModal = ref(false);
    const newUnit = ref({
      name: "",
      symbol: "",
    });
    const selectedUnitForDelete = ref(null);
    const showDeleteConfirmModal = ref(false);
    const errorsAdminData = ref();
    const showErrors = ref(false);
    const isMainOpen = ref(true);
    const store = useStore();
    // Units are shared by machines and printing machines, with permissions of
    // their own.
    const canAddUnit = computed(() => hasPermission(unitPermissionsConst.add));
    const canDeleteUnit = computed(() =>
      hasPermission(unitPermissionsConst.delete)
    );
    const canAddPlate = computed(() =>
      hasPermission(platePermissionsConst.add)
    );
    const createPlatesData = computed(() => store.getters.getCreatePlatesData);
    const unitsData = computed(() => store.getters.getUnitsData);
    const createUnitData = computed(() => store.getters.getCreateUnitData);
    const deleteUnitData = computed(() => store.getters.getDeleteUnitData);
    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const fetchUnits = async () => {
      store.dispatch("getUnits");
    };

    const createUnit = async () => {
      if (!canAddUnit.value) {
        return;
      }
      try {
        await store.dispatch("createUnit", newUnit.value);
      } catch (error) {
        console.error("Error creating unit:", error);
      }
    };

    const deleteUnit = async (unitId) => {
      if (!canDeleteUnit.value) {
        return;
      }
      try {
        await store.dispatch("deleteUnit", unitId);
      } catch (error) {
        console.error("Error deleting unit:", error);
      }
    };

    const confirmDeleteUnit = (unit) => {
      if (!canDeleteUnit.value) {
        return;
      }
      selectedUnitForDelete.value = unit;
      showDeleteConfirmModal.value = true;
    };

    const executeDeleteUnit = async () => {
      if (selectedUnitForDelete.value) {
        await deleteUnit(selectedUnitForDelete.value.pk);
        showDeleteConfirmModal.value = false;
        selectedUnitForDelete.value = null;
      }
    };

    const create = () => {
      if (!canAddPlate.value) {
        return;
      }
      // Mapuj operational_costs żeby przekonwertować type na unit dla API
      const mappedOperationalCosts = operational_costs.value.map((cost) => ({
        name: cost.name,
        amount: cost.amount,
        unit: cost.type && cost.type.pk ? cost.type.pk : null,
      }));

      plateObj.value.operational_costs = mappedOperationalCosts;
      showErrors.value = true;
      store.dispatch("createPlates", plateObj.value);
    };

    const customFilter = (option, label, search) => {
      if (!search) return true;
      const searchLower = search.toLowerCase();
      return (
        option.name.toLowerCase().includes(searchLower) ||
        option.symbol.toLowerCase().includes(searchLower)
      );
    };

    const addCost = () => {
      operational_costs.value.push({
        name: "",
        type: "",
        amount: 0,
      });
    };

    const cancel = () => {
      router.push({ name: "PlatesList", path: "/plates" });
    };

    onMounted(() => {
      fetchUnits();
    });

    watch(
      () => createPlatesData.value,
      function (newValue) {
        if (newValue.status === 201) {
          router.push({ name: "PlatesList", path: "/plates" }).then(() => {
            store.dispatch("showToaster", {
              type: "success",
              content: "Nowa płyta została dodana",
            });
          });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    watch(
      () => unitsData.value,
      function (newValue) {
        // Dodaj właściwość 'value' do każdej jednostki
        units.value = (newValue?.data?.results || []).map((unit) => ({
          ...unit,
          value: unit.pk, // Użyj pk jako value
        }));
      },
      { deep: true }
    );

    watch(
      () => createUnitData.value,
      function (newValue) {
        if (newValue?.status === 201) {
          showUnitModal.value = false;
          newUnit.value = { name: "", symbol: "" };
          store.dispatch("getUnits");
          store.dispatch("showToaster", {
            type: "success",
            content: "Nowa jednostka została dodana",
          });
        } else if (newValue?.status && newValue.status !== 201) {
          store.dispatch("showToaster", {
            type: "error",
            content: "Błąd podczas dodawania jednostki",
          });
        }
      }
    );

    watch(
      () => deleteUnitData.value,
      function (newValue) {
        if (newValue?.status === 204) {
          showDeleteConfirmModal.value = false;
          selectedUnitForDelete.value = null;
          store.dispatch("getUnits");
          store.dispatch("showToaster", {
            type: "success",
            content: "Jednostka została usunięta pomyślnie!",
          });
        } else if (newValue?.status && newValue.status !== 204) {
          store.dispatch("showToaster", {
            type: "error",
            content:
              "Błąd podczas usuwania jednostki: " +
              (newValue?.data?.detail || "Nieznany błąd"),
          });
        }
      },
      { deep: true }
    );

    watch(
      () => operational_costs.value,
      function () {
        // Operational costs changed
      },
      { deep: true }
    );

    return {
      canAddUnit,
      canDeleteUnit,
      canAddPlate,
      plateObj,
      errorsAdminData,
      showErrors,
      create,
      operational_costs,
      addCost,
      units,
      customFilter,
      showUnitModal,
      newUnit,
      createUnit,
      cancel,
      selectedUnitForDelete,
      showDeleteConfirmModal,
      confirmDeleteUnit,
      executeDeleteUnit,
      deleteUnitData,
      isMainOpen,
      chevronMainClass,
    };
  },
  computed: {
    // chevronMainClass() {
    //   return isMainOpen ? "fa-chevron-down" : "fa-chevron-right";
    // },
  },
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}

.ibox-toggle:hover {
  color: #333;
}

.modal {
  z-index: 1050;
}
.modal.show {
  display: block;
}

.multiselect-with-buttons {
  display: flex;
  align-items: center;
  gap: 5px;
}

.add-unit-btn {
  flex-shrink: 0;
  height: 38px;
  width: 38px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
}

/* Dostosowanie Multiselect */
:deep(.multiselect) {
  min-height: 38px;
}

:deep(.multiselect-dropdown) {
  max-height: 200px;
}

:deep(.multiselect-option) {
  padding: 8px 12px;
}

:deep(.multiselect-option:hover) {
  background-color: #f8f9fa;
}

/* Flexible multiselect styling */
.flexible-multiselect {
  min-width: 200px;
  max-width: 400px;
}

:deep(.flexible-multiselect .multiselect-dropdown) {
  min-width: 300px;
  max-width: 500px;
}

:deep(.flexible-multiselect .multiselect-option) {
  white-space: normal;
  overflow: visible;
  word-wrap: break-word;
  min-height: auto;
}

:deep(.flexible-multiselect .multiselect-option.is-selected) {
  color: #333 !important;
}

:deep(.flexible-multiselect .multiselect-option.is-selected:hover) {
  color: #333 !important;
}

:deep(.flexible-multiselect .multiselect-option:hover) {
  background-color: #e9ecef !important;
  color: #495057 !important;
}

.option-with-delete {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 2px 0;
  gap: 8px;
}

.delete-btn {
  flex-shrink: 0;
  opacity: 0.7;
  transition: opacity 0.2s;
  padding: 2px 6px;
  font-size: 12px;
  line-height: 1;
  margin-right: 0;
}

.option-text {
  flex: 1;
  overflow: visible;
  white-space: normal;
  word-wrap: break-word;
}

.option-with-delete:hover .delete-btn {
  opacity: 1;
}

/* Style dla flex-inputs */
.flex-inputs {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.flex-inputs > div {
  flex: 1;
  min-width: 0;
}

.flex-inputs input {
  width: 100%;
}
</style>
